module.exports = __webpack_public_path__ + "img/组 363.ae881abc.png";